import React from 'react';
import { buildPrintSummary } from './printSummary';
import './PrintSummaryView.css';

export default function PrintSummaryView({ data, range, title, onClose }) {
  const summary = buildPrintSummary(data, range, { title });

  return (
    <div className="print-summary-overlay">
      <div className="print-summary-toolbar no-print">
        <button type="button" onClick={() => window.print()}>Imprimir / Salvar PDF</button>
        <button type="button" onClick={onClose}>Fechar</button>
      </div>

      <div className="print-summary-content">
        <h1>{summary.title}</h1>
        <p className="print-summary-period">{summary.periodLabel}</p>
        <p className="print-summary-narrative">{summary.narrative}</p>

        <h2>Resumo</h2>
        <table className="print-summary-stats">
          <tbody>
            {summary.stats.map((stat) => (
              <tr key={stat.label}>
                <td>{stat.label}</td>
                <td>{stat.value}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {summary.topCities.length > 0 && (
          <>
            <h2>Cidades</h2>
            <ul>
              {summary.topCities.map((city) => (
                <li key={city.city}>{city.city}{city.count ? ` · ${city.count}×` : ''}</li>
              ))}
            </ul>
          </>
        )}

        {summary.topVenues.length > 0 && (
          <>
            <h2>Locais mais visitados</h2>
            <ul>
              {summary.topVenues.map((venue, i) => (
                <li key={i}>{venue.nameApprox}{venue.count ? ` · ${venue.count}×` : ''}</li>
              ))}
            </ul>
          </>
        )}

        {summary.activeDays.length > 0 && (
          <>
            <h2>Dias com mais eventos</h2>
            <ul>
              {summary.activeDays.map((day) => (
                <li key={day.date}>{day.date} · {day.count} eventos</li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
